"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantRiskLevel = exports.CardPaymentApprovalStatus = void 0;
var CardPaymentApprovalStatus;
(function (CardPaymentApprovalStatus) {
    CardPaymentApprovalStatus["PENDING"] = "PENDING";
    CardPaymentApprovalStatus["APPROVED"] = "APPROVED";
    CardPaymentApprovalStatus["REJECTED"] = "REJECTED";
})(CardPaymentApprovalStatus = exports.CardPaymentApprovalStatus || (exports.CardPaymentApprovalStatus = {}));
var MerchantRiskLevel;
(function (MerchantRiskLevel) {
    MerchantRiskLevel["LOW"] = "LOW";
    MerchantRiskLevel["MEDIUM"] = "MEDIUM";
    MerchantRiskLevel["HIGH"] = "HIGH";
})(MerchantRiskLevel = exports.MerchantRiskLevel || (exports.MerchantRiskLevel = {}));
